import { Mail, Phone, MapPin, Twitter, Linkedin, Instagram } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer id="contact" className="bg-[#F1ECDC] border-t border-[#D8D7C8]">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              {/* <div className="w-8 h-8 bg-gradient-to-br from-[#1F473E] to-[#49685E] rounded"></div> */}
              <span className="text-xl text-[#1F473E]">Co-Work@Level 3</span>
            </div>
            <p className="text-[#49685E]">
              Premium coworking spaces for modern professionals.
            </p>
            <div className="flex space-x-4 mt-4">
              <button 
                type="button"
                onClick={() => {/* Add Twitter link when available */}} 
                className="text-[#49685E] hover:text-[#1F473E] transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </button>
              <button 
                type="button"
                onClick={() => {/* Add LinkedIn link when available */}} 
                className="text-[#49685E] hover:text-[#1F473E] transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </button>
              <button 
                type="button"
                onClick={() => {/* Add Instagram link when available */}} 
                className="text-[#49685E] hover:text-[#1F473E] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </button>
            </div>
          </div>
          <div>
            <h4 className="text-[#1F473E] mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-[#49685E]">
                <Mail className="w-5 h-5 mr-2 text-[#1F473E]" />
                coworkatlevel3@gmail.com
              </li>
              <li className="flex items-center text-[#49685E]">
                <Phone className="w-5 h-5 mr-2 text-[#1F473E]" />
                +91 9686663056
              </li>
              <li className="flex items-start text-[#49685E]">
                <MapPin className="w-5 h-5 mr-2 text-[#1F473E] mt-0.5 flex-shrink-0" />
                <div>
                  <div className="mb-1">
                    Remco BHEL Layout <br />
                    Ideal Homes Township <br />
                    Rajarajeshwari Nagar, Bengaluru<br />
                    Karnataka - 560098
                  </div>
                  <a 
                    href="https://maps.app.goo.gl/soKJ3EcMjqUASMvb7" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#1F473E] hover:underline text-sm font-medium"
                  >
                    Get Directions
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-[#D8D7C8] flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#49685E] mb-4 md:mb-0">
            © {currentYear} Co-Work@Level 3. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/privacy/privacy_policy.html" className="text-[#49685E] hover:text-[#1F473E]">Privacy Policy</a>
            <a href="/terms/" className="text-[#49685E] hover:text-[#1F473E]">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}